module.exports = __webpack_public_path__ + "img/team-bg.312a71ca.jpg";